import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useChartStore, useSelectOptionsStore } from "../../hooks";
import { LoadingData, ErrorMessage, SelectForm as Select } from "../../ui";

const optionsChart = {
  chart: {
    height: 350,
    type: "bar",
    toolbar: {
      show: false, // ❌ oculta todo el toolbar (incluida descarga)
    },
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        chart: {
          height: 350,
        },
        legend: {
          position: "bottom",
        },
      },
    },
    {
      breakpoint: 480,
      options: {
        chart: {
          height: 350,
        },
        legend: {
          show: true,
        },
        plotOptions: {
          bar: {
            columnWidth: "80%",
          },
        },
        stroke: {
          show: false,
        },
      },
    },
  ],
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 5,
      colors: {
        backgroundBarColors: ["#EDF2F7"],
        backgroundBarRadius: 5,
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [],
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
  },
  colors: ["#6B94D2", "#BD75B5", "#FD9843"],
  grid: {
    show: false,
  },
  legend: {
    show: true,
    position: "bottom", // top, bottom, left, right
    horizontalAlign: "center", // left, center, right
    fontSize: "12px",
    markers: {
      size: 7,
      shape: "circle",
      strokeWidth: 1,
    },
  },
};

export const PatientSurgeryByTrackChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, error, filters } = useSelector(
    (state) => state.admin.chart.patientSurgeryByTrack
  );

  const { getDataPatientSurgeryByTrack, setChartFilter } = useChartStore();

  const {
    // Props
    proceduresParent,
    procedures,
    years,

    // Methods
    startGetProcedurechildren,
  } = useSelectOptionsStore();

  // States ------------------------------------------------//
  const [procedureParentId, setProcedureParentId] = useState(
    "8c868bfb-6d09-439d-af03-043883a9b8c9"
  );

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleYearChange = (e) => {
    setChartFilter("patientSurgeryByTrack", "year", e.target.value);
  };

  const handleProcedureIdChange = (e) => {
    setChartFilter("patientSurgeryByTrack", "procedureId", e.target.value);
  };

  const handleprocedureParentIdChange = (e) => {
    setProcedureParentId(e.target.value);
    setChartFilter("patientSurgeryByTrack", "procedureId", "");
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data && filters.year && filters.procedureId) {
      getDataPatientSurgeryByTrack(filters);
    }
  }, [data, getDataPatientSurgeryByTrack, filters]);

  useEffect(() => {
    if (procedureParentId !== "") {
      startGetProcedurechildren(procedureParentId);
    }
  }, [procedureParentId]);

  const isAnyLoading =
    isLoading || proceduresParent.isLoading || procedures.isLoading;

  const errorMessage = error || proceduresParent.error || procedures.error;

  const chartOptions = data
    ? {
        ...optionsChart,
        xaxis: {
          ...optionsChart.xaxis,
          categories: data.categories,
        },
        plotOptions: {
          bar: {
            ...optionsChart.plotOptions.bar,
            columnWidth: `${data.series.length * 15}%`,
          },
        },
        stroke: {
          show: true,
          width: data.series.length > 1 ? 5 : 0,
          colors: ["transparent"],
        },
      }
    : optionsChart;

  return (
    <>
      <div className="vstack gap-3">
        <div className="row justify-content-between gy-2">
          <div className="col-12 col-md-4 col-xl-5">
            <Select
              label={"Procedimiento"}
              name={"procedureParentId"}
              options={proceduresParent.data}
              labelKey={"name"}
              onInputChange={handleprocedureParentIdChange}
              value={procedureParentId}
            />
          </div>
          {procedures.data.length > 0 && (
            <div className="col-12 col-md-4 col-xl-5">
              <Select
                label={"Propósito"}
                name={"procedureId"}
                options={procedures.data}
                labelKey={"name"}
                onInputChange={handleProcedureIdChange}
                value={filters.procedureId}
              />
            </div>
          )}
          <div className="col-12 col-md-4 col-xl-2">
            <Select
              label={"Año"}
              name={"year"}
              options={years.data}
              labelKey={"label"}
              onInputChange={handleYearChange}
              value={filters.year}
            />
          </div>
        </div>

        {isAnyLoading && <LoadingData />}

        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

        {data && (
          <Chart
            options={chartOptions}
            series={data.series || []}
            type="bar"
            width="100%"
            height={350}
          />
        )}
      </div>
    </>
  );
};
